import { fetchApi } from '@/config/axiosSetting.ts';
import { ContactInformationOwnerType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';

export const PatchDamagedContactInformationQueryFunction = (
  id: string,
  params?: ContactInformationOwnerType,
  damaged_id?: string,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/property/reports/${id}/accident_users/damaged/user_information/owner/contact_information/`,
    data: params,
    params: {
      damaged_id,
    },
  });
